<template>
  <v-card class="mx-auto" max-width="400">
    <v-card-title>
      <v-row align="start" no-gutters>
        <v-img
            src="@/assets/LogoBenefitoDesktop.svg"
            max-width="200"
            max-height="200"
            alt="Benefito Logo"
        ></v-img>
        <span class="ml-3">Benefito10</span>

      </v-row>
    </v-card-title>

    <v-card-text>
      <v-list dense>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>Credit: Unlimited</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>Validity: 30 Days</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>Roaming: Included</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-card-text>

    <v-card-actions>
      <v-btn
          color="primary"
          block
         @click="addNewPrepaidSimClientServiceLocal"
          target="_blank"
      >
        Buy Online
      </v-btn>
    </v-card-actions>
  </v-card>
  <v-dialog max-width="600px" v-model="showDialogRedirectToOnlinePayment" @update:model-value="handleDialogClose"
            @keydown.esc="handleEscape">
    <v-card>
      <v-card-title>
        <h4 class="highlighted">Order added, redirect to BT Pay </h4>

      </v-card-title>
      <!--      newClientLevel0-->
      <v-card-text v-if="true">
        <v-row class="border1">
          <v-col  cols="12">
            <a :href="btUrl" target="_blank" >Link to BT Pay</a>
          </v-col>

        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import {log} from "@/composables/useLog";
import {addNewClientService} from "@/composables/useAddNewClientService";
import useGetLoggedIn from "@/composables/useGetLoggedIn";
import {getPrepaidCardsServicesList} from "@/composables/useGetServicesAPI";

export default {
  name: "SimCardComponent",
  data() {
    return {
      newClientServiceClientID:1,
      client_id:null,
      service_id:null,
      token:null,
      service:null,
      prepaidCardServicesList:null,
      numberOfSims:1,
      deliveryTypeID:1,
      listaMsisdn:[],
      showDialogRedirectToOnlinePayment:false,
      btUrl:""
    }
  },
  created() {
    const { getLoggedIn, user, loggedIn, token } = useGetLoggedIn();
    getLoggedIn().then(() => {
      this.showDialogAddNewClientService=true;
// Logs from the provided instructions
      log("dupa created in Dashboard avem:");
      log("autorizare in Dashboard after getLoggedIn");
      log("user:");
      log(user);
      log("loggedIn: " + loggedIn.value);
      log("token: " + token.value);
      this.client_id=user.value.client_id
      this.token = token.value
      getPrepaidCardsServicesList(this.token,this.client_id).then((response) => {
        log("------------aici after getPrepaidCardsServicesList----------")
        this.prepaidCardServicesList= response.services_list
        log(this.prepaidCardServicesList)
        this.service= this.prepaidCardServicesList.find(service => service.nickname === 'Benefito10');
      })
    });

  },
  methods: {
    handleDialogClose(value) {
      // Emitted when dialog visibility changes
      log("am primit eveniment ca v-dialog s.a inchis")
      if (!value) {
        // alert("am primit eveniment ca v-dialog s.a inchis si no value")
        this.$emit('dialogClosedEvent');
      }
    },
    handleEscape() {
      // alert("am primit eveniment ca v-dialog a apasat escape")
      // Emitted specifically when Escape is pressed
      this.$emit('dialogEscapedEvent');
    },
    redirectToPaymentProcessor(url) {
      log("welcome in redirectToPaymentProcessor("+url+")")
      this.showDialogRedirectToOnlinePayment=true
      // }
    },
    async addNewPrepaidSimClientServiceLocal() {
      // alert("calling addNewPrepaidSimClientServiceLocal")
        const form = {
          newClientServiceClientID:this.client_id,
          newClientServiceServiceID:this.service.id,
          newClientServiceNumberOfSims:this.numberOfSims,
          newClientServiceDeliveryTypeID:this.deliveryTypeID,
          newClientServiceListaMsisdn:this.listaMsisdn,
        }
        log(form)
        this.loading = true
        addNewClientService(this.token,form).then((response)=>{
          log("response din addNewClientService prepaid card cu plata online:")
          log(response)
          if(response.error==true){
            alert(response.message)
          }else{
            // alert(response.btUrl)
            this.btUrl=response["btUrl"]
            // this.$emit("newClientServiceAddedEvent",this.btUrl);
            this.showDialogAddNewClientService=false
            this.redirectToPaymentProcessor()
          }
          this.loading=false
        })
      }
    },
};
</script>

<style scoped>
.v-img {
  border-radius: 50%;
}
</style>